module.exports = __webpack_public_path__ + "static/media/bank-mehr.cd72b278.png";